/**
 * SOLID Review
 * S — Strong. One concern: the server's health, asked for the banner and the indicator.
 * O — Good. A new health read is one more pass-through.
 * L — N/A — no inheritance hierarchy.
 * I — Strong. Exactly the health op of `ClientUseCases`.
 * D — Strong. One port interface, injected.
 */
import type { ICommandNothing } from '../../domain/ports/schemas/TableMoves';
import type { IEntityHealthReport } from '../../domain/ports/schemas/HealthMoves';
import type { IPortClientServerHealth } from '../ports/contracts';
import type { TPortResult } from '../ports/PortResult';
import type { IUseCase } from '../uml-components/IUseCase';
import { PassThroughUseCase } from '../shared/PassThroughUseCase';

export interface IConfigDepHealthContext {
  readonly health: IPortClientServerHealth;
}

/**
 * THE SERVER'S HEALTH (frontend strict-ports plan, FE5a, 2026-10-04). MaintenanceBanner and HealthIndicator each probed
 * `/health`; they ask the Application now. A read with nothing to decide or keep — the two components' thresholds and
 * rendering are their own.
 */
export class HealthContext {
  readonly checkServerHealth: IUseCase<ICommandNothing, TPortResult<IEntityHealthReport>>;

  constructor(deps: IConfigDepHealthContext) {
    const { health } = deps;
    this.checkServerHealth = new PassThroughUseCase<ICommandNothing, TPortResult<IEntityHealthReport>>((ctx) => health.probe(ctx));
  }
}
